import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

import { _cursorBubble } from "../utils/_cursorBubble";
import { _section } from "../utils/_section";
import { formatNumberWithComma } from "../utils/_formattedNumberWithComma";
import { _backgroundGradient } from "../utils/_backgroundGradient";
import { _homePageUniforms } from "./Masthead";

class OurJourney extends MainClass {
    totalPrepared: number | null;
    background: _backgroundGradient | null;

    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);
        this.totalPrepared = null;

        this.background = null;

        this.init();
    }

    init() {
        this.fetchData();

        if (!_section.bodyGradient())
            this.background = new _backgroundGradient({ target: this.selector, uniforms: _homePageUniforms });
    }

    fetchData() {
        // Fetch data from our custom WordPress endpoint
        fetch(wpApiSettings.statisticsEndpoint, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": wpApiSettings.nonce, // Include nonce for authenticated requests
            },
        })
            .then((response) => {
                // Check if the response is ok
                if (!response.ok) {
                    throw new Error("Network response was not ok: " + response.statusText);
                }
                return response.json();
            })
            .then((data) => {
                const totalPreparedElement = document.getElementById("totalPrepared");
                if (totalPreparedElement) {
                    totalPreparedElement.innerText = `${formatNumberWithComma(data.total_prepared)} `;
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }
}

export default OurJourney;
